/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { AppConfig } from "@nf/constants";
import { AxiosSubscriber } from "../../../../services";
import { HTTP_METHOD } from "@nf/constants";
import { IConfigModel, IComponentConfigModel } from "../models";
import { lastValueFrom, Observable, Observer } from "rxjs";

export class ClientConfigService {
  get url(): string {
    return "/v2";
  }

  public getConfiguration = (): Observable<IConfigModel> =>
    new Observable(
      (observer: Observer<IConfigModel>) =>
        new AxiosSubscriber(observer, {
          axiosConfig: {
            timeout: 60000,
            headers: {
              Authorization: "",
            },
          },
          method: HTTP_METHOD.GET,
          url: `${this.url}/config/${AppConfig.ConfigId}`,
        })
    );

  public getComponent = (
    referenceId: string
  ): Observable<IComponentConfigModel> => {
    return new Observable(
      (observer: Observer<IComponentConfigModel>) =>
        new AxiosSubscriber(observer, {
          axiosConfig: {
            timeout: 10000,
            headers: {
              Authorization: "",
            },
          },
          method: HTTP_METHOD.GET,
          url: `${this.url}/config/${AppConfig.ConfigId}/component/${referenceId}`,
        })
    );
  };

  public getComponentByUrl = (
    referenceUrl: string
  ): Observable<IComponentConfigModel> =>
    new Observable(
      (observer: Observer<IComponentConfigModel>) =>
        new AxiosSubscriber(observer, {
          axiosConfig: {
            headers: {
              Authorization: "",
            },
          },
          method: HTTP_METHOD.GET,
          url: referenceUrl,
        })
    );

  public getComponentByUrlAsPromise = (
    referenceUrl: string
  ): Promise<IComponentConfigModel> =>
    lastValueFrom(this.getComponentByUrl(referenceUrl));
}
